// AI Provider configurations
export const AI_PROVIDERS = [
  { id: 'openai', name: 'OpenAI' },
  { id: 'claude', name: 'Claude' },
  { id: 'gemini', name: 'Google Gemini' },
  { id: 'datatrace', name: 'DataTrace', isDataSource: true }
];

// Contact type configurations
export const GOVERNMENT_CONTACTS = [
  { id: 'countyRegistrar', label: 'County - Registrar of Deeds', required: true },
  { id: 'countyTreasurer', label: 'County - Treasurer', required: true },
  { id: 'cityTownship', label: 'City/Township', required: true },
  { id: 'village', label: 'Village', required: false }
];

export const ORDER_CONTACTS = [
  { id: 'orderContact1', label: 'Order Contact 1', required: true },
  { id: 'orderContact2', label: 'Order Contact 2', required: false }
];

export const SECONDARY_CONTACTS = [
  { id: 'secondaryContact1', label: 'Secondary Contact 1', required: false },
  { id: 'secondaryContact2', label: 'Secondary Contact 2', required: false }
];

// Refinance field definitions
export const REFI_FIELDS = [
  // Loan Officer (if present, this is the main contact person)
  { id: 'LoanOfficerName', label: 'Loan Officer Name', section: 'loanOfficer', spsCode: 'N/A' },
  { id: 'LoanOfficerPhone', label: 'Loan Officer Phone', section: 'loanOfficer', spsCode: 'N/A' },
  { id: 'LoanOfficerEmail', label: 'Loan Officer Email', section: 'loanOfficer', spsCode: 'N/A' },

  // Processor (if no loan officer, this is the main contact person)
  { id: 'ProcessorName', label: 'Processor Name', section: 'processor', spsCode: 'N/A' },
  { id: 'ProcessorPhone', label: 'Processor Phone', section: 'processor', spsCode: 'N/A' },
  { id: 'ProcessorEmail', label: 'Processor Email', section: 'processor', spsCode: 'N/A' },

  // Processor 2 (Additional Processor)
  { id: 'Processor2Name', label: 'Processor 2 Name', section: 'processor2', spsCode: 'N/A' },
  { id: 'Processor2Phone', label: 'Processor 2 Phone', section: 'processor2', spsCode: 'N/A' },
  { id: 'Processor2Email', label: 'Processor 2 Email', section: 'processor2', spsCode: 'N/A' },

  // Borrower 1
  { id: 'Borrower1FirstName', label: 'First Name', section: 'borrower1', spsCode: 'Order.Contacts.Individual1.FirstName' },
  { id: 'Borrower1MiddleName', label: 'Middle Name', section: 'borrower1', spsCode: 'Order.Contacts.Individual1.MiddleName' },
  { id: 'Borrower1LastName', label: 'Last Name', section: 'borrower1', spsCode: 'Order.Contacts.Individual1.LastName' },
  { id: 'Borrower1Suffix', label: 'Suffix', section: 'borrower1', spsCode: 'Order.Contacts.Individual1.Suffix' },
  { id: 'Borrower1Cell', label: 'Cell Phone', section: 'borrower1', spsCode: 'Order.Contacts.Individual1.Cell' },
  { id: 'Borrower1Email', label: 'Email', section: 'borrower1', spsCode: 'Order.Contacts.Individual1.Email' },
  { id: 'Borrower1Address1', label: 'Street Address', section: 'borrower1', spsCode: 'Order.Contacts.Individual1.Address.Address1' },
  { id: 'Borrower1Address2', label: 'Address Line 2 (Unit/Apt)', section: 'borrower1', spsCode: 'Order.Contacts.Individual1.Address.Address2' },
  { id: 'Borrower1City', label: 'City', section: 'borrower1', spsCode: 'Order.Contacts.Individual1.Address.City' },
  { id: 'Borrower1State', label: 'State', section: 'borrower1', spsCode: 'Order.Contacts.Individual1.Address.State' },
  { id: 'Borrower1Zip', label: 'Zip Code', section: 'borrower1', spsCode: 'Order.Contacts.Individual1.Address.Zip' },

  // Borrower 2
  { id: 'Borrower2FirstName', label: 'First Name', section: 'borrower2', spsCode: 'Order.Contacts.Individual2.FirstName' },
  { id: 'Borrower2MiddleName', label: 'Middle Name', section: 'borrower2', spsCode: 'Order.Contacts.Individual2.MiddleName' },
  { id: 'Borrower2LastName', label: 'Last Name', section: 'borrower2', spsCode: 'Order.Contacts.Individual2.LastName' },
  { id: 'Borrower2Suffix', label: 'Suffix', section: 'borrower2', spsCode: 'Order.Contacts.Individual2.Suffix' },
  { id: 'Borrower2Cell', label: 'Cell Phone', section: 'borrower2', spsCode: 'Order.Contacts.Individual2.Cell' },
  { id: 'Borrower2Email', label: 'Email', section: 'borrower2', spsCode: 'Order.Contacts.Individual2.Email' },
  { id: 'Borrower2Address1', label: 'Street Address', section: 'borrower2', spsCode: 'Order.Contacts.Individual2.Address.Address1' },
  { id: 'Borrower2Address2', label: 'Address Line 2 (Unit/Apt)', section: 'borrower2', spsCode: 'Order.Contacts.Individual2.Address.Address2' },
  { id: 'Borrower2City', label: 'City', section: 'borrower2', spsCode: 'Order.Contacts.Individual2.Address.City' },
  { id: 'Borrower2State', label: 'State', section: 'borrower2', spsCode: 'Order.Contacts.Individual2.Address.State' },
  { id: 'Borrower2Zip', label: 'Zip Code', section: 'borrower2', spsCode: 'Order.Contacts.Individual2.Address.Zip' },


  // Loan Information
  { id: 'LoanNumber', label: 'Loan Number', section: 'loanInfo', spsCode: 'Order.Loans.Number' },
  { id: 'LoanAmount', label: 'Loan Amount', section: 'loanInfo', spsCode: 'Order.Loans.Funding.LoanAmount' },
  { id: 'ContractDate', label: 'Contract Date', section: 'loanInfo', spsCode: 'Order.Dates.ContractDate' },
  { id: 'EstimatedClosingDate', label: 'Estimated Closing Date', section: 'loanInfo', spsCode: 'Order.Dates.EstimatedClosingDate' },
  { id: 'LienPosition', label: 'Lien Position', section: 'loanInfo', spsCode: 'N/A (Order Notes)' },

  // Marital Status (only shown if there are multiple borrowers)
  { id: 'MaritalStatus', label: 'Marital Status (Joint Entry)', section: 'maritalStatus', spsCode: 'N/A' },

  // National Rate
  { id: 'NationalRate', label: 'CLR / National Rate', section: 'nationalRate', spsCode: 'NationalRate' },
];

// Refinance section titles
export const REFI_SECTION_TITLES = {
  loanOfficer: 'Loan Officer',
  processor: 'Processor',
  processor2: 'Processor 2 (Optional)',
  borrower1: 'Borrower 1 Information',
  borrower2: 'Borrower 2 Information (Optional)',
  loanInfo: 'Mortgage Information',
  maritalStatus: 'Marital Status',
  nationalRate: 'CLR / National Rate'
};

// Product type options
export const PRODUCT_TYPES = [
  { id: 'ladybird-deed', label: 'Ladybird Deed Out (Property Report & Deed Prep)', residential: 'RESI PROPERTY REPORT', commercial: 'COMM PROPERTY REPORT' },
  { id: 'junior-loan-policy', label: 'Junior Loan Policy', value: 'RESI JLP' },
  { id: 'full-title-heloc', label: 'Full Title Heloc', residential: 'RESIDENTIAL REFI', commercial: 'COMMERCIAL REFINANCE' },
  { id: 'full-title-fixed', label: 'Full Title (Fixed/CD Issued)', residential: 'RESIDENTIAL REFI', commercial: 'COMMERCIAL REFINANCE' }
];

// Vesting options
export const VESTING_OPTIONS = [
  { id: 'sole-ownership', label: 'Sole Ownership', values: [', as his sole and separate property', ', as her sole and separate property', ', as sole and separate property', ', a single man', ', a single woman'] },
  { id: 'joint-tenants', label: 'Joint Tenants with Right of Survivorship', value: ', as joint tenants with full rights of survivorship' },
  { id: 'tenants-entirety', label: 'Tenants by the Entirety', value: ', as tenants by the entirety' },
  { id: 'tenants-common', label: 'Tenants in Common', value: ', as tenants in common' }
];

// Form fields configuration
export const FORM_FIELDS = [
  { id: 'PropertyAddress1', label: 'Property Address (Street)', section: 'property' },
  { id: 'PropertyAddress2', label: 'Property Address 2 (Suite/Unit)', section: 'property' },
  { id: 'PropertyCity', label: 'Property City', section: 'property' },
  { id: 'PropertyState', label: 'Property State', section: 'property' },
  { id: 'PropertyZip', label: 'Property Zip Code', section: 'property' },
  { id: 'PropertyCounty', label: 'Property County', section: 'property' },
  { id: 'PropertyFIPS', label: 'FIPS Code', section: 'property' },
  { id: 'PropertyMunicipality', label: 'Municipality/Township', section: 'property' },
  { id: 'PropertyAPN', label: 'APN / Parcel ID (Optional)', section: 'property' },
];

// Section titles for form fields
export const SECTION_TITLES = {
  property: 'Property Information',
  transaction: 'Transaction Details',
  order: 'Order Information',
  agent: 'Agent Information'
};

// Mock SoftPro contacts database
export const MOCK_CONTACTS = {
  government: [
    { id: 1, name: 'Kent County Register of Deeds', phone: '(616) 632-7580', email: 'registerofdeeds@kentcountymi.gov' },
    { id: 2, name: 'Kent County Treasurer', phone: '(616) 632-7500', email: 'treasurer@kentcountymi.gov' },
    { id: 3, name: 'Grand Rapids City Assessor', phone: '(616) 456-3062', email: 'assessor@grcity.us' },
    { id: 4, name: 'Ottawa County Register of Deeds', phone: '(616) 994-4520', email: 'rod@miottawa.org' },
    { id: 5, name: 'Ottawa County Treasurer', phone: '(616) 994-4510', email: 'treasurer@miottawa.org' },
    { id: 6, name: 'Holland Township', phone: '(616) 396-3690', email: 'info@hct.holland.mi.us' },
    { id: 7, name: 'Village of Spring Lake', phone: '(616) 842-1393', email: 'clerk@springlakevillage.org' },
  ],
  order: [
    { id: 8, name: 'Sarah Johnson', phone: '(616) 555-1234', email: 'sjohnson@suntitle.com' },
    { id: 9, name: 'Michael Chen', phone: '(616) 555-2345', email: 'mchen@suntitle.com' },
    { id: 10, name: 'Emily Rodriguez', phone: '(616) 555-3456', email: 'erodriguez@suntitle.com' },
    { id: 11, name: 'David Thompson', phone: '(616) 555-4567', email: 'dthompson@suntitle.com' },
  ],
  secondary: [
    { id: 12, name: 'Lisa Martinez', phone: '(616) 555-5678', email: 'lmartinez@suntitle.com' },
    { id: 13, name: 'James Wilson', phone: '(616) 555-6789', email: 'jwilson@suntitle.com' },
    { id: 14, name: 'Amanda Brown', phone: '(616) 555-7890', email: 'abrown@suntitle.com' },
  ]
};

// FIPS code mapping
export const FIPS_MAP = {
  'Kent': '26081',
  'Ottawa': '26139'
};
